import * as React from 'react';
import { Row } from "reactstrap";
import { ICase } from 'src/share/types/case/case';

interface ICaseInformationProps {
  caseInfo: ICase
}
export class Circumstances extends React.PureComponent<ICaseInformationProps> {
  public render() {
    const { circumstances, agencyCode } = this.props.caseInfo
    return (
      <Row>
        <h5 className="circumstances-title">Missing Circumstances :</h5>
        <p className="circumstances-content">
          {circumstances ? circumstances : agencyCode ? 'Unknown' : ''}
        </p>
      </Row>
    );
  }
}

